// A user's designation may be a single role ("CSM") or multiple,
// comma-separated ("CSM,CM") for people who wear two hats.
export const getUserRoles = (user) => {
  const raw = user?.role || user?.designation || "";
  return String(raw).split(",").map((r) => r.trim().toLowerCase()).filter(Boolean);
};

// hasRole(user, "cm") or hasRole(user, "admin", "ceo")
export const hasRole = (user, ...roles) => {
  const userRoles = getUserRoles(user);
  return roles.some((r) => userRoles.includes(r.toLowerCase()));
};